<script setup>
import { ref } from 'vue';
import { useBlockSafe } from '@/composables/useBlockSafe';
import CarCard from '@/components/cards/CarCard.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination } from 'swiper/modules';
/*import 'swiper/css';

import 'swiper/css/pagination';
import 'swiper/css/navigation';

import '../../assets/styles/swiper-custom.scss';
*/
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
const {
  id,
  backgroundColor,
  spacingTop,
  spacingBottom,
  title,
  items,
  hasTitle,
  hasItems,
  hasAnyContent,
} = useBlockSafe(props.data);

const isLocked = ref(true);
const onSwiper = (swiper) => {
  isLocked.value = swiper.isLocked;
};

const onLockToggle = (swiper) => {
  isLocked.value = swiper.isLocked;
};
</script>
<template>
  <section
    v-if="hasAnyContent"
    :id="id"
    class="section"
    :class="[
      backgroundColor ? `bg-${backgroundColor}` : '',
      spacingTop ? `section--top-${spacingTop}` : 'section--top-xl',
      spacingBottom ? `section--bottom-${spacingBottom}` : 'section--bottom-xl',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div class="container">
      <div class="car-equipment">
        <h2
          v-if="hasTitle"
          class="mb-0 car-equipment__title h2 text-center"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
          v-html="title"
        ></h2>
        <div v-if="hasItems" class="car-equipment__slider">
          <Swiper
            :slides-per-view="'auto'"
            :space-between="16"
            :modules="[Navigation, Pagination]"
            :navigation="{
              prevEl: '.car-equipment__slider-navigation-prev',
              nextEl: '.car-equipment__slider-navigation-next',
            }"
            :pagination="{
              el: '.car-equipment__slider-pagination',
              clickable: true,
            }"
            data-aos="fade-up"
            data-aos-easing="ease-out-cubic"
            @swiper="onSwiper"
            @lock="onLockToggle"
            @unlock="onLockToggle"
          >
            <SwiperSlide v-for="(item, index) in items" :key="index">
              <CarCard
                :background-color="backgroundColor"
                :view="'equipment'"
                :url="item?.url"
                :in-stock="item?.in_stock"
                :image="item?.thumbnails || item?.image || item?.brand"
                :empty-image="!item?.image && !item?.thumbnails"
                :name="item?.title"
                :price="item?.pricing?.price_old"
                :discount="item?.pricing?.discount"
                :current-price="item?.pricing?.price_current"
                :currency="item?.pricing?.currency"
                :max-payment="item?.financing?.max_payment"
                :monthly-payment="item?.financing?.monthly_payment"
                :kasko="item?.financing?.kasko"
                :tooltip="item?.financing?.tooltip"
                :parameters="item?.parameters"
                :calculator-link="data?.calculator_link"
                :is-stock-car="item.status_car === 'stock'"
              />
            </SwiperSlide>
          </Swiper>
          <div
            v-show="!isLocked"
            class="swiper-pagination car-equipment__slider-pagination"
            data-aos="fade-up"
            data-aos-easing="ease-out-cubic"
          ></div>
          <div
            v-show="!isLocked"
            class="swiper-navigation car-equipment__slider-navigation"
            data-aos="fade-up"
            data-aos-easing="ease-out-cubic"
          >
            <Button
              type="button"
              rounded
              variant="outlined"
              class="car-equipment__slider-navigation-prev button-prev js-button-car-equipment-prev"
            >
              <CIcon
                class="button-prev__icon"
                :name="
                  backgroundColor === 'black'
                    ? 'direction-white'
                    : 'direction-black'
                "
                width="16"
                height="16"
              />
            </Button>
            <Button
              type="button"
              rounded
              variant="outlined"
              class="car-equipment__slider-navigation-next button-next js-button-car-equipment-next"
            >
              <CIcon
                class="button-next__icon"
                :name="
                  backgroundColor === 'black'
                    ? 'direction-white'
                    : 'direction-black'
                "
                width="16"
                height="16"
              />
            </Button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use 'sass:math';
.car-equipment {
  display: flex;
  flex-direction: column;
  gap: 56px;
  @include media-breakpoint-up(sm) {
    gap: 80px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 80);
  }
  &__title {
    margin: 0;
  }
  &__slider {
    .swiper {
      height: 100%;
      overflow: visible;
      width: 100%;
      @include media-breakpoint-up(md) {
        overflow: hidden;
      }
    }
    .swiper-slide {
      align-self: stretch;
      height: auto;
      max-width: calc(100vw - 48px);
      width: 328px;
      @include media-breakpoint-up(sm) {
        width: 356px;
      }
      @include media-breakpoint-up(md) {
        width: 384px;
      }
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(width, 384);
      }
    }
  }
}
</style>
